module.exports = __webpack_public_path__ + "7c6508b5455b9ae54d90684dca9a2025.svg";